// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';
import { Flex } from '@atlassian/eoc-flex';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled(Flex)({
	height: '24px',
	alignItems: 'center',
	columnGap: token('space.100', '8px'),
	padding: `0px ${token('space.050', '4px')}`,
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconWrapper = styled(Flex)({
	width: '16px',
	flexShrink: 0,
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TimeText = styled(Flex)({
	width: '45px',
	flexShrink: 0,
	columnGap: token('space.050', '4px'),
	justifyContent: 'flex-end',
	alignItems: 'center',
	font: token('font.body.UNSAFE_small'),
	fontWeight: token('font.weight.semibold'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RuleBody = styled(Flex)({
	columnGap: token('space.050', '4px'),
	minWidth: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const Rectangle = styled.div<{ width: number; backgroundColor: string }>((props) => ({
	height: '8px',
	minWidth: '10px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${props.width}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundColor: props.backgroundColor,
	borderRadius: token('border.radius.100', '1px'),
}));

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DashedLines = styled.div({
	width: '50px',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- needs manual remediation
	border: '1px dashed #dee4ea',
	flexShrink: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RuleDetail = styled(Flex)({
	columnGap: token('space.050', '4px'),
	alignItems: 'center',
	whiteSpace: 'nowrap',
});
